<template>
  <v-app :style="{background: $vuetify.theme.themes['dark'].background}">    
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
      color="#363636"
      style="margin-top: 56px;"
    >
      <v-list class="pt-0">
        <v-list-item
          v-for="link in links"
          :key="link.id"
          router :to="{name: link.routeName}"
          class="menu"
        >
          <v-list-item-icon>
            <v-icon v-text="link.icon" color="fanhiveHoney"></v-icon>
          </v-list-item-icon>
          <v-list-item-content class="pa-0">
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
	
	<v-app-bar 
      app 
      color="fanhiveHoney"
      dark
      height="56"
    >
      <v-container class="pa-0 fill-height" style="max-width: 450px;">
        <v-app-bar-nav-icon @click="drawer = !drawer" color="white"></v-app-bar-nav-icon>
      <v-btn icon color="black" v-if="isLoggedIn" class="ml-3" @click="$router.push({name: 'honey-points'})">
        <v-icon>mdi-hexagon-slice-4</v-icon>
        {{wallet.honeyPointsBalance}}
      </v-btn>
      <v-btn icon color="black" v-if="isLoggedIn" class="ml-3" @click="$router.push({name: 'player-ratings'})">
        <v-icon>mdi-star-half-full</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <a href="/">
          <img src="@/assets/logo-black.png" class="logo"/>
        </a>
      </v-toolbar-title>
      </v-container>
    </v-app-bar>

    <v-main>
      <v-container style="max-width: 450px;">
        <v-row>
          <v-col class="pa-0">
            <v-sheet
              class="mx-auto"
              max-width="700"
              style="background-color: #414141;height: 50px;"
              v-if="showSlideMenu !== ''"
            >
              <v-slide-group
                multiple
                class="pt-2"
              >
                <v-slide-item
                  v-for="item in slideMenuItems"
                  :key="item.cipId"
                >
                  <v-btn
                    style="color:#ffffff !important;font-weight: normal !important;"
                    :input-value="item.active"
                    text
                    @click="selectFilter(item.cupId)"
                  >
                    {{ item.cupName }}
                  </v-btn>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>

            <v-container>
              <v-row>
                <v-col cols="12" sm="12" class="pa-5" style="min-height: 300px;">
                  <router-view></router-view>
                </v-col>
              </v-row>
            </v-container>
            
            <v-bottom-navigation 
              fixed
              background-color="amber darken-1"
              dark
              v-if="!isLoggedIn && !hideYellowBar"
            >
              <v-btn value="favorites" v-on:click="goTo('join')">
                <b style="color: #212121">Join</b>
                <v-icon color="grey darken-4">mdi-account-plus-outline</v-icon>
              </v-btn>

              <v-btn value="nearby" v-on:click="goTo('login')">
                <b style="color: #212121">Log In</b>
                <v-icon color="grey darken-4">mdi-lock-open-outline</v-icon>
              </v-btn>
            </v-bottom-navigation>

            <v-snackbar
              v-model="snackbar.show"
              :timeout="snackbar.timeout"
              top
              color="#2196f3"
              style="margin-top: 64px;"
            >
              {{ snackbar.text }}

              <template v-slot:action="{ attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar.show = false"
                >
                  Close
                </v-btn>
              </template>
            </v-snackbar>
            <v-dialog
              v-model="dialogCookies"
              scrollable
              overlay-opacity="0.9"
            >
              <v-card>
                <v-card-title>We value your privacy</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="color:#ffffff;" class="honeyBold">
                  <p>
                    We use cookies to allow you to login securely to Fanhive and for us to remember who you are.
                  </p>
                  <p>
                    <b>We never share your personal details with anyone else!</b>
                  </p>
                  <p>
                    Please accept our cookies policy to enable access to Fanhive. <a href="" v-on:click.prevent="viewPrivacyPolicy">View policy</a>
                  </p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    color="fanhiveHoney"
                    text
                    @click="cancelCookies"
                  >
                    Cancel
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    outlined
                    color="fanhiveHoney"
                    @click="acceptCookies"
                    style="color: #ffffff !important;border: 1px solid #ffb300;"
                  >
                    Accept
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ma-0 pa-0">
          <v-footer bottom padless>
              <v-container style="background-color:#202020;max-width: 450px;">
                <v-row>
                  <v-col class="pa-0 pt-6 follow">
                    Follow <img src="@/assets/logo.png" class="logo-follow"/>
                  </v-col>
                </v-row>
                <v-row style="text-align:center;">
                  <v-col><a href="https://twitter.com/Fanhive_uk"><img src="@/assets/twitter.png" /></a></v-col>
                  <v-col><a href="https://www.facebook.com/fanhive"><img src="@/assets/facebook.png" /></a></v-col>
                  <v-col><a href="https://www.instagram.com/fanhive.co.uk/"><img src="@/assets/instagram.png" /></a></v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <hr style="border-top:1px;">
                  </v-col>
                </v-row>
                <v-row style="text-align:center;" class="footer-links">
                  <v-col>
                    <v-container>
                      <v-row>
                        <v-col cols="6" v-for="link in footerLinks" :key="link.id">
                          <router-link :to="{name: link.routeName}">{{link.text}}</router-link>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="text-center">
                    <a href="https://www.trustpayments.com"><img src="@/assets/TRUST_Payments_White.png" style="height: 25px;padding-right: 10px;" /></a>
                    <img src="@/assets/mastercard_circles_92px_2x.png" style="height: 25px;padding-right: 10px" />
                    <img src="@/assets/Visa_Brandmark_White_RGB_2021.png" style="height: 25px;padding-right: 10px" />
                    <img src="@/assets/apple-pay-payment-mark-logo-174E25DB63-seeklogo.com.png" style="height: 25px;padding-right: 10px" />
                    <img src="@/assets/google-pay-mark.png" style="height: 25px;padding-right: 10px" />
                  </v-col>
                </v-row>
                <v-row v-if="version" class="small-text" v-bind:class="{ 'version-spacing': !isLoggedIn }">
                  <v-col cols="12" class="text-center">
                    &copy; 2022 Fanhive. All rights reserved.
                  </v-col>
                  <v-col @click="versionCheck()">
                    Client version: {{staticVersionNumber}}
                  </v-col>
                  <v-col class="text-center" v-if="userSub">
                    {{userSub.userName}}
                  </v-col>
                  <v-col @click="versionCheck()" style="text-align:right">
                    Server version: {{version.versionNumber}}
                  </v-col>
                </v-row>
              </v-container>
            </v-footer>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import _ from 'lodash';
import Socket from "./../plugins/socket";

export default {
  name: "layout",
  data: () => ({
    drawer: false,
    group: null,
    slideMenuItems: null,
    dialogCookies: false,
    allLinks: [
    {
      id: 1,
      text: 'Join',
      icon: 'mdi-account-plus-outline',
      routeName: 'join',
      loggedIn: false
    },
    {
      id: 2,
      text: 'Log In',
      icon: 'mdi-lock-open',
      routeName: 'login',
      loggedIn: false
    },
    {
      id: 100,
      text: 'Profile',
      icon: 'mdi-account',
      routeName: 'profile',
      loggedIn: true,
      alwaysShow: false
    },
    {
      id: 3,
      text: 'Competitions',
      icon: 'mdi-calendar',
      routeName: 'active-competitions',
      loggedIn: true,
      alwaysShow: true
    },
    {
      id: 101,
      text: 'My Entries',
      icon: 'mdi-ticket',
      routeName: 'my-entries',
      loggedIn: true,
      alwaysShow: false
    },
    {
      id: 103,
      text: 'My Honey Points',
      icon: 'mdi-hexagon-slice-4',
      routeName: 'honey-points',
      loggedIn: true,
      alwaysShow: false
    },
    {
      id: 104,
      text: 'Player Ratings',
      icon: 'mdi-star-half-full',
      routeName: 'player-ratings',
      loggedIn: true,
      alwaysShow: false
    },
    {
      id: 105,
      text: 'Fan Leaderboard',
      icon: 'mdi-flag-checkered',
      routeName: 'fan-leaderboard',
      loggedIn: true,
      alwaysShow: false
    },
    {
      id: 4,
      text: 'Past Winners',
      icon: 'mdi-history',
      routeName: 'past-winners',
      loggedIn: true,
      alwaysShow: true
    },
    {
      id: 11,
      text: 'Log Out',
      icon: 'mdi-exit-to-app',
      routeName: 'logout',
      loggedIn: true
    }],
    footerLinks: [
      {
        id: 1,
        text: 'About',
        routeName: 'about'
      },
      {
        id: 2,
        text: 'Contact',
        routeName: 'contact'
      },
      {
        id: 3,
        text: 'Terms and Conditions',
        routeName: 'terms-and-conditions'
      },
      {
        id: 4,
        text: 'Privacy Policy',
        routeName: 'privacy-policy'
      },
      {
        id: 5,
        text: 'FAQ',
        routeName: 'faq'
      },
      {
        id: 6,
        text: 'Competitions',
        routeName: 'active-competitions'
      },
      {
        id: 7,
        text: 'Sport Clubs',
        routeName: 'sport-clubs'
      }
    ],
    connection: null,
    snackbar: {
      show: false,
      text: '',
      timeout: 2000
    }
  }),
  computed:{
    version () {
      return this.$store.getters.version;
    },
    staticVersionNumber () {
      return this.$store.getters.staticVersionNumber;
    },
    theme(){
      return 'dark'
    },
    links () {
      if(this.$store.state.isLoggedIn) {
        return _.filter(this.allLinks, (o) => {
          return o.loggedIn || o.alwaysShow;
        });
      } else {
        return _.filter(this.allLinks, (o) => {
          return !o.loggedIn || o.alwaysShow;
        });
      }
    },
    showSlideMenu () {
      return this.$store.getters.showSlideMenu;
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
    userSub () {
      return this.$store.getters.userSub;
    },
    wallet () {
      if(!this.$store.getters.wallet){
        return {
          balance: 0,
          honeyPointsBalance: 0
        };
      }
      return this.$store.getters.wallet;
    },
    hideYellowBar () {
      return this.$store.getters.hideYellowBar;
    },
  },
  methods: {
    getVersion: function () {
      this.$store.dispatch('getVersion').then(() => {
        //version set in store
        }, error => {
            console.log(error);
        });
    },
    versionCheck: function () {
      if(this.version.versionNumber !== this.$store.getters.staticVersionNumber) {
        console.log('Upgrade available');
        window.location.reload(true);
      } else {
        console.log('You have the latest version');
      }
    },
    goTo: function(routeName)  {
      this.$router.push({name: routeName})
    },
    handleMessageClose(){
      console.log('Setting connectionid to null');
      this.$store.commit('setConnectionId', null);
    },
    handleMessage(msg){
      try {
        if(msg !== "ClosingSocket") {
          var message = JSON.parse(msg);
          switch(message.messageType){
            case "ConnectionId": {
              console.log(`Connection ID being set to ${message.connectionId}`);
              this.$store.commit('setConnectionId', message.connectionId);
              break;
            }
            case "WalletCreditsUpdated": {
              console.log('Wallet credits updated socket message received');
              this.$store.commit('setUpdatingWalletCredits', 2);
              break;
            }
            case "WalletHoneyPointsUpdated": {
              console.log('Wallet honey points updated socket message received');
              this.$store.commit('setUpdatingWalletHoneyPoints', 2);
              break;
            }
            case "EntryCreated": {
              console.log('Entry created socket message received');
              this.$store.commit('setCreatingEntry', 2);
              break;
            }
            case "EntryUpdated": {
              console.log('Entry updated socket message received');
              this.$store.commit('setUpdatingEntry', 2);
              break;
            }
            case "UserUpdated": {
              console.log('User updated socket message received');
              this.$store.commit('setUpdatingUser', 2);
              break;
            }
            case "PaymentRequestCreated": {
              console.log('Payment Request created socket message received');
              this.$store.commit('setCreatingPaymentRequest', 2);
              break;
            }
            case "PaymentRequestUpdated": {
              console.log('Payment Request updated socket message received');
              this.$store.commit('setUpdatingPaymentRequest', 2);
              break;
            }
          } 
        } else {
          console.log(msg);
        }
      } catch (error) {
        console.log(error);
        console.log(`2Non JSON socket message received: ${msg}`);
      }
    },
    getSlideMenu: function (slug) {
      let scope = this;
      var slugParams = {
        slug: slug,
        params: ''
      };
      this.$store.dispatch('getCustom', slugParams).then(response => {
        scope.slideMenuItems = response;
        scope.slideMenuItems.unshift({cupId: 'all', cupName: 'All'});
        }, error => {
            console.log(error);
        });
    },
    selectFilter: function (cupId) {
      this.$store.commit('setSelectedCupId', cupId);
    },
    viewPrivacyPolicy: function () {
      this.$localStorage.set('viewedCookiesPopup', true);
      this.$store.commit('setViewedCookiesPopup', true);
      this.dialogCookies = false;
      this.$router.push({name: 'privacy-policy'});
    },
    acceptCookies: function () {
      this.dialogCookies = false;
      this.$localStorage.set('viewedCookiesPopup', true);
      this.$store.commit('setViewedCookiesPopup', true);
      this.$localStorage.set('acceptedCookies', true);
      this.$store.commit('setAcceptedCookies', true);
    },
    cancelCookies: function () {
      this.dialogCookies = false;
      this.$localStorage.set('viewedCookiesPopup', true);
      this.$store.commit('setViewedCookiesPopup', true);
    }
  },
  created(){
    this.getVersion();
    Socket.$on("message", this.handleMessage);
    Socket.$on("close", this.handleMessageClose);
    if(this.showSlideMenu !== ''){
      this.getSlideMenu(this.showSlideMenu);
    }
    if(!this.$store.getters.viewedCookiesPopup) {
      this.dialogCookies = true;
    }
  },
  beforeDestroy(){
    Socket.$off("message", this.handleMessage)
    Socket.$off("close", this.handleMessageClose)
  },
  watch: {
      group () {
        this.drawer = false
      },
      showSlideMenu (newVal) {
        if(newVal) {
          this.getSlideMenu(newVal);
        }
      }
    }
};
</script>